const required_fields = [
   "ip_address",
   "ip_version",
   "company",
   "description"
]

export default required_fields